import { useMediaQuery } from "@mui/material";

export const useIsSmallDown=() => useMediaQuery(theme => theme.breakpoints.down("sm"));
export const useIsMediumDown=() => useMediaQuery(theme => theme.breakpoints.down("md"));
export const useIsMediumUp=() => useMediaQuery(theme => theme.breakpoints.up("md"));
export const useIsLargeUp=() => useMediaQuery(theme => theme.breakpoints.up("lg"));

